<template>
        <div class="s-activity-common">
            <div class="s-activity-common-top">
                <img :src="banner" class="s-activity-banner" alt />
                <a href="javascript:;" v-if="this.isMirror11" class="s-activity-apply-button" @click="e=>this.changeTestLink(this.test)"></a>
                <a href="javascript:;" @click="goBack" class="go-back s-activity-back"></a>
            </div>
        </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
        title: String,
        banner: String,
        applyUrl:String,
        test:String
    },
    data(){
        return {
            isMirror11:true
        }
    },
    computed:{
        ...mapState(['mirror','mirrorStatus'])
    },
    mounted(){
        if(this.$route.query.type==='mirror11'){
            this.isMirror11=false;
        }
    },
    methods:{
        goBack(){
            this.$router.push('/details/xcb')
        },
        changeTestLink(type) {        
            console.log(type)    
           this.$test(`${type}${this.mirrorStatus ? this.mirrorStatus+1 : ""} a-register-2`);
           this.$router_push(this.mirror.current_link)
        }
    }
};
</script>

<style lang="scss" scoped>

</style>